// src/data/growthWalls.js

// 4つの壁の定義
export const growthWalls = {
  WALL_1_ACTION: {
    name: "行動の壁",
    description: "新しい挑戦の「最初の一歩」を踏み出すことに難しさを感じている状態です。",
    advice: [
      "【5分ルール】:「5分だけやってみる」と決め、とにかく行動を開始するハードルを下げましょう。",
      "【最小単位化】: 目標を「今日できる、最も簡単な作業」にまで分解し、具体的なタスクに落とし込みましょう。",
      "【手本を真似る】: 既にできている人のやり方を、まずは完全に模倣することから始めてみましょう。",
    ]
  },
  WALL_2_CONTINUATION: {
    name: "継続の壁",
    description: "行動を始めたものの、成長が実感できず、モチベーションの維持に苦労している状態です。",
    advice: [
      "【習慣化】: 毎日決まった時間・場所で行うなど、行動を「意志」ではなく「習慣」の力で動かしましょう。",
      "【進捗の可視化】: どんなに小さな進歩でもカレンダーに印をつけるなど、日々の頑張りを目に見える形にしましょう。",
      "【仲間を見つける】: 同じ目標を持つ仲間と進捗を報告し合うことで、健全な強制力が生まれます。",
    ]
  },
  WALL_3_THINKING: {
    name: "思考の壁",
    description: "行動は習慣化したが、成果が頭打ちになる「プラトー期」。量をこなすだけでなく、思考の質を変える必要があります。",
    advice: [
      "【意図的な振り返り】:「なぜ上手くいったのか？」「次はどうすればもっと良くなるか？」を具体的に言語化する時間を設けましょう。",
      "【フィードバックを求める】: 自分より優れた人にフィードバックを求め、自分では気づけない「無意識の癖」を指摘してもらいましょう。",
      "【限界的練習】: 自分の「心地よい範囲」を少しだけ超える、意図的に難しい課題に挑戦し続けましょう。",
    ]
  },
  WALL_4_CREATION: {
    name: "創造の壁",
    description: "スキルは習熟しましたが、それを応用して新しい価値を創造したり、他者に影響を与えることに難しさを感じている状態です。",
    advice: [
      "【教える】: あなたが学んだことを、初心者に教えてみましょう。知識が体系化され、より深い理解に至ります。",
      "【知識の統合】: 習得したスキルと、全く異なる分野の知識を意図的に掛け合わせ、新しいアイデアを生み出しましょう。",
      "【発信する】: あなたの経験や学びを、ブログやSNSなどで発信してみましょう。新しい協力者や機会が生まれます。",
    ]
  }
};

// 診断用の質問
export const wallDiagnosisQuestions = [
  { id: 'w_q1', text: '新しいスキルを学ぶ際、何から手をつければ良いか分からず、行動を先延ばしにしがちだ。', wall: 'WALL_1_ACTION' },
  { id: 'w_q2', text: '最初の数週間は意欲的に取り組めるが、すぐに飽きてしまい、三日坊主になることが多い。', wall: 'WALL_2_CONTINUATION' },
  { id: 'w_q3', text: '練習量は十分なはずなのに、あるレベルから上達が感じられず、伸び悩んでいる。', wall: 'WALL_3_THINKING' },
  { id: 'w_q4', text: 'スキルは身についたが、それをどう仕事や創作活動に活かせば良いか分からない。', wall: 'WALL_4_CREATION' },
  { id: 'w_q5', text: '完璧な計画を立てることに時間をかけすぎてしまい、なかなか実行に移せない。', wall: 'WALL_1_ACTION' },
  { id: 'w_q6', text: '日々のタスクに追われ、学習や練習を継続するための時間を確保するのが難しい。', wall: 'WALL_2_CONTINUATION' },
  { id: 'w_q7', text: 'いつも同じやり方で問題を解決しており、自分のアプローチを見直す機会が少ない。', wall: 'WALL_3_THINKING' },
  { id: 'w_q8', text: '自分の知識やスキルを、他者に分かりやすく説明したり、教えたりすることに難しさを感じる。', wall: 'WALL_4_CREATION' },
];
